import { useContext, useState } from 'react';

import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@repo/videa-components/src/index';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { ExternalPatientContext } from '../constants';
import { IframeMessageType, ModalType } from '../types';

export const TrialExpiredCollapsible = () => {
  const [isOpen, setIsOpen] = useState(true);

  const { trackEvent } = useTrackEvent();
  const { externalPatientId, externalImageId, imageId, patientId } = useContext(
    ExternalPatientContext,
  );

  return (
    <Collapsible
      className="vai-px-2 vai-bg-zinc-700 vai-text-white vai-p-3 vai-rounded-md vai-flex vai-flex-col data-[state=open]:vai-gap-2"
      onOpenChange={(open) => {
        setIsOpen(open);
        trackEvent(mixpanelEvents.externalCollapsibleToggle, {
          externalPatientId,
          externalImageId,
          patientId,
          imageId,
          isOpen: open,
          source: 'TRIAL_EXPIRED',
        });
      }}
      open={isOpen}
    >
      <CollapsibleTrigger className="vai-w-full vai-flex vai-items-center vai-justify-between">
        {isOpen ? (
          <div className="vai-rounded-full vai-bg-zinc-800 vai-text-zinc-200 vai-px-3 vai-py-1 vai-uppercase vai-font-inter vai-text-[12px]">
            <Trans>Trial Expired</Trans>
          </div>
        ) : (
          <p className="vai-font-inter vai-font-semibold">
            <Trans>Get full-time AI assistance</Trans>
          </p>
        )}
        <FontAwesomeIcon icon={isOpen ? faMinus : faPlus} />
      </CollapsibleTrigger>

      <CollapsibleContent className="vai-flex vai-flex-col vai-gap-2">
        <p className="vai-font-sans vai-font-semibold">
          <Trans>Get full-time AI assistance</Trans>
        </p>
        <div
          className="vai-rounded-lg vai-overflow-hidden vai-h-28"
          style={{
            backgroundImage:
              'url(assets/images/external/image-with-findings.png)',
            backgroundSize: 'cover',
            backgroundPosition: '0 75%',
          }}
        />
        <p className="vai-font-sans vai-text-sm">
          <Trans>
            Trial ended. Continue to access all AI features by upgrading.
          </Trans>
        </p>
        {/* TODO: Add back in when content is ready */}
        {/* <Button
          className="vai-font-inter vai-text-sm vai-font-normal vai-text-blue-500 hover:vai-text-blue-500 vai-underline !vai-p-0 !vai-h-auto vai-self-start hover:vai-bg-transparent"
          onClick={() => {
            trackEvent(mixpanelEvents.externalAiImpactModalOpen, {
              externalPatientId,
              externalImageId,
              patientId,
              imageId,
              source: 'TRIAL_EXPIRED',
            });
            window.parent.postMessage(
              {
                type: IframeMessageType.MODAL_OPEN,
                payload: {
                  type: ModalType.AI_IMPACT,
                  patientId,
                  imageId,
                  externalPatientId,
                  externalImageId,
                },
              },
              '*',
            );
          }}
          variant="ghost"
        >
          <Trans>View AI Impact</Trans>
        </Button> */}

        <Button
          className="vai-mt-2 !vai-font-medium"
          onClick={() => {
            trackEvent(mixpanelEvents.externalUpgradeModalOpen, {
              externalPatientId,
              externalImageId,
              patientId,
              imageId,
              source: 'TRIAL_EXPIRED',
            });
            window.parent.postMessage(
              {
                type: IframeMessageType.MODAL_OPEN,
                payload: {
                  type: ModalType.UPGRADE,
                  patientId,
                  imageId,
                  externalPatientId,
                  externalImageId,
                },
              },
              '*',
            );
          }}
        >
          <Trans>Upgrade to Detect AI</Trans>
        </Button>
      </CollapsibleContent>
    </Collapsible>
  );
};
